import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Profile from "./pages/profile/Profile";
import Register from "./pages/register/Register";

function App() {
  return (
    <>
      {/* <Register /> */}
      {/* <Login /> */}
      <Home />
      {/* <Profile /> */}
    </>
  );
}

export default App;
